exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-dropdown {\n  width: 200px; }\n\n.problem-dropdown {\n  width: 400px; }\n\n.problem-dialog-container, .options-container {\n  margin: 0.5rem; }\n\n.items-count {\n  display: initial;\n  width: 15%; }\n\n.icon-size {\n  font-size: 23px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/rog-confirmation-dialog/rog-confirmation-dialog.component.scss
// module id = ../../../../../src/app/rog-confirmation-dialog/rog-confirmation-dialog.component.scss
// module chunks = main